import React from "react";
import { ErrorList, ErrorStrings, surveyFrequencyOptions, } from "../../../components/Enums";
import { SurveySelectOptionContent } from "../DropdownCustomStyles";
import { CustomSelect, ErrorText, PortalFormFieldGroup, PortalFormLabel } from "src/components";
import Skeleton from "src/scenes/Statistics/components/Skeleton";
import { getAvailableSurveyShowInOptions } from "../../../components/Enums";

export const SurveyFrequencyField = (props) => {
    const { inputErrors, selectShowIn, selectShowFrequency, survey, loading, featureFlags } = props;
    const availableShowInOptions = getAvailableSurveyShowInOptions(featureFlags);

    const getErrorStrings = (...errs) => inputErrors.filter(err => errs.includes(err)).map(err => ErrorStrings[err]);
    const showInError = getErrorStrings(ErrorList.EMPTY_SHOW_IN);
    const showFrequencyError = getErrorStrings(ErrorList.EMPTY_SHOW_FREQUENCY);

    return (
        <>
            <PortalFormFieldGroup>
                <PortalFormLabel>
                    Show Survey In:
                </PortalFormLabel>
                { loading ?
                    <Skeleton height="50px" width="100%" animation="wave" />
                    :
                    <CustomSelect
                        defaultValue={availableShowInOptions[0]}
                        value={ availableShowInOptions.find(obj => obj.value == survey.showIn) }
                        options={ availableShowInOptions }
                        onChange={(choice) => selectShowIn(choice)}
                        height="46px"
                        radius="8px"
                        fontSize="0.9375rem"
                        renderOption={SurveySelectOptionContent}
                        renderValue={SurveySelectOptionContent}
                    />
                }
                <ErrorText>{showInError}</ErrorText>
            </PortalFormFieldGroup>

            <PortalFormFieldGroup>
                <PortalFormLabel>
                    Select Survey Frequency?
                </PortalFormLabel>
                { loading ?
                    <Skeleton height="50px" width="100%" animation="wave" />
                    :
                    <CustomSelect
                        defaultValue={surveyFrequencyOptions[0]}
                        options={ surveyFrequencyOptions }
                        onChange={(choice) => selectShowFrequency(choice)}
                        value={ surveyFrequencyOptions.find(obj => obj.value == survey.showFrequency) }
                        height="46px"
                        radius="8px"
                        fontSize="0.9375rem"
                        renderOption={SurveySelectOptionContent}
                        renderValue={SurveySelectOptionContent}
                    />
                }
                <ErrorText>{showFrequencyError}</ErrorText>
            </PortalFormFieldGroup>
        </>
    );
};
